<template>
  <div class="">
    <div class="">
      <div class="col-12">
        <b-navbar class="interior" toggleable="xd" type="dark" variant>
          <b-navbar-brand to="/" class="h-100 d-flex justify-content-center">
            <img
              class="img-fluid w-50 ml-2"
              src="../assets/imgs/coca/logo-academia-digital-blanco.svg"
              alt="Academia Digital"
            />
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <div class="breadcrumbs white">
            <router-link to="/dashboard">Inicio</router-link> /
            <strong>{{ seccion }}</strong>
          </div>

          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <!-- <b-nav-item class="fG" to="/maestros-de-la-parrilla">¿Qué es Maestros de la Parrilla?</b-nav-item> -->
              <b-nav-item class="pt-4" to="/dashboard/">Inicio</b-nav-item>
              <b-nav-item to="/curso/enfriadores">Enfriadores</b-nav-item>
              <b-nav-item to="/curso/anaqueles">Anaqueles</b-nav-item>
              <b-nav-item to="/curso/exhibiciones-adicionales/exhibicion-1">Exhibiciones Adicionales</b-nav-item>
              <b-nav-item to="/curso/bodega/bodega-1">Bodega</b-nav-item>
              <b-nav-item to="/curso/tips/tips-1">Tips</b-nav-item>
              <b-nav-item class="pb-4" to="/">Cerrar Sesión</b-nav-item>

              <template
                v-if="
                  this.$store.state.user != null &&
                  this.$store.state.user.nombre != '' &&
                  this.$store.state.user.nombre != undefined
                "
              >
                <b-nav-item class="fG" to="/cursos">Master Classes</b-nav-item>
                <b-nav-item class="fG" to="/recetario"
                  >Recetario 2021</b-nav-item
                >
                <b-nav-item class="fG" to="/videorecetas"
                  >Video Recetas</b-nav-item
                >

                <b-nav-item class="fG" title="Cerrar sesión" @click="logout()">
                  Cerrar sesión
                  <!-- <i class="fas fa-power-off"></i> -->
                </b-nav-item>
              </template>

              <template
                v-if="
                  this.$store.state.user != null &&
                  this.$store.state.user.nombre_usuario == 'adminmdlp'
                "
              >
                <b-nav-item class="fG" title="Cerrar sesión" @click="logout()">
                  Cerrar sesión
                  <!-- <i class="fas fa-power-off"></i> -->
                </b-nav-item>
              </template>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["seccion", "subseccion"],
  data() {
    return {
      matriculaadmin: "",
      nombre: "",
    };
  },
  mounted: function () {
    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    this.$store.state.user = JSON.parse(
      localStorage.getItem("useracademiadigitalreportes")
    );
    console.log({ user: this.$store.state.user });
  },
  methods: {
    logout() {
      //this.$cookie.delete("useracademiadigital");
      localStorage.removeItem("useracademiadigital");
      localStorage.removeItem("useracademiadigitalreportes");
      this.$router.push("/");
    },
  },
};
</script>

